<div class="shipment-dialog" *ngIf="relatedShipments.length">
    <div class="shipment" [ngClass]="{'shipment-retry':hasErrorShipment}" *ngFor="let shipment of relatedShipments; let i= index">
        <div class="shipment_star" [ngClass]="{'active': shipment.isStarred}">
            <i class="fas fa-star"></i>
        </div>
        <div class="shipment_title">
            <a class="shipment_name" [routerLink]=" ['/shipyard/shipments/detail', shipment.shipmentHeaderId]">
                <app-button [buttonSize]="'primary'" [buttonStyle]="'text'">{{
                    shipment.amazonShipmentId
                    ? shipment.amazonShipmentId
                    : "Draft: " + shipment.shipmentHeaderId
                    }}</app-button>
            </a>
            <div class="shipment_id font_size_10" [matTooltip]="!shipment.isSuccess ? shipment.errorMessage : ''" [ngClass]="!shipment.isSuccess ? 'error' : ''">{{ shipment.shipmentName }}</div>
        </div>
        <span class="shipment_link" (click)="openOnAmazon(shipment)" *ngIf="shipment.amazonShipmentId">
                <i class="fal fa-external-link-square-alt"></i>
        </span>
        <div class="shipment_sku-qty"><div class="shipment_label font_size_10">SKUs</div> <div>{{ shipment.totalSkus }}</div></div>
        <div><div class="shipment_label font_size_10">Qty</div> <div>{{ shipment.totalQty | number }}</div></div>
        <div class="shipment_plannedonDate">
            <div *ngIf="shipment.isCreatedByAmazon !== null">
              <span class="shipment_label">Created By: </span>{{ shipment.isCreatedByAmazon?  'Amazon' : 'Seller'}}
            </div>
            <div *ngIf="shipment.plannedOnDate" >
              <span class="shipment_label">Planned date: </span>{{ shipment.plannedOnDate | date:'MM/dd/yy' }}
            </div>
          </div>
        <app-button *ngIf="!shipment.isSuccess" class="retry-btn" [buttonSize]="'action'" [spin]="shipment.spin" [isDisabled]="shipment.spin" (click)="openDialog(shipment)">
            Retry 
        </app-button>        
    </div>
</div>